export default function Marquee() {
  const words = [
    "Motion Graphics",
    "Art Direction",
    "Branding",
    "Identity",
    "Visual Design",
    "Campaign",
    "Storytelling",
    "Cinema",
  ];
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-ink-border bg-ink-surface py-8 overflow-hidden"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap font-oswald uppercase text-5xl md:text-7xl text-bone/90 tracking-tight">
        {[0, 1].map((g) => (
          <div key={g} className="flex shrink-0" aria-hidden={g === 1}>
            {words.map((w, i) => (
              <span key={`${g}-${i}`} className="flex items-center pr-16">
                <span>{w}</span>
                <span className="ml-16 text-bone/30">•</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
